"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";

export function SignedInAppChrome({
  navigation,
  children,
}: {
  navigation: ReactNode;
  children: ReactNode;
}) {
  const pathname = usePathname();
  const isJoinPage = pathname === "/join" || pathname?.startsWith("/join/");

  return (
    <>
      {!isJoinPage && navigation}
      <main
        className={isJoinPage
          ? "min-h-screen bg-(--mk-ink)"
          : "ap-offset-mobile-bar min-h-screen bg-(--mk-ink) lg:ml-56 lg:pt-0"}
        id="main-content"
      >
        <div className="mx-auto max-w-7xl px-5 py-6 sm:px-8 lg:px-12">
          {children}
        </div>
      </main>
    </>
  );
}
